import React from "react";
import OrderForm from "../../../components/pages/admin-panels/orders/order-form/OrderForm";

export default function Orders() {
  return (
    <div>
      <OrderForm />
    </div>
  );
}
